import React from "react";
import PropTypes from "prop-types";

import { FileInput, WrapperContainer } from "../../../../components";
import { log, notificationService, t } from "../../../../services";
import { fileTypes, strCode } from "../../../../consts";

const BinFile = ({ isLoading, fwuVersion, setFwuVersion }) => {
  const handleFileChange = (file) => {
    if (!file) {
      setFwuVersion((prev) => {
        return { ...prev, binFile: file };
      });

      return;
    }

    if (!file.name.endsWith(".bin")) {
      log.warn("BinFile: Invalid bin file extension. " + file.name);
      notificationService.showError({
        title: t(strCode.INVALID_BIN_FILE_TITLE),
        message: t(strCode.INVALID_BIN_FILE_DESCRIPTION)
      });

      return;
    }

    setFwuVersion((prev) => {
      return { ...prev, binFile: file };
    });
  };

  return (
    <WrapperContainer pt={16} width={"100%"}>
      <FileInput
        id={"bin-file"}
        title={t(strCode.BIN_FILE_TITLE)}
        file={fwuVersion?.binFile}
        setFile={handleFileChange}
        disabled={isLoading}
        fileType={fileTypes.bin}
      />
    </WrapperContainer>
  );
};

BinFile.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  fwuVersion: PropTypes.shape({ fwuVersion: PropTypes.object, binFile: PropTypes.object })
    .isRequired,
  setFwuVersion: PropTypes.func.isRequired
};

export default BinFile;
